<template>
  <div class="anu-upload-component">
    <div class="row">
      <div class="box box-primary">
        <div class="box-header with-border">
          <h1 class="box-title">Export</h1>
        </div>
        <div class="box box-primary">
          <div class="box-header with-border">
            <h1 class="box-title">Export</h1>
          </div>
          <div class="box-body">
            <form class="form form-horizontal">
              <email-input :field="email"></email-input>
              <button type="button" class="btn btn-default" @click="emailReport()">
                Send
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Reporting Confirmation -->
    <modal ref="confirmationModal" v-if="confirming">
      <template slot="header">
        <h4 class="modal-title" id="confirmationModalLabel">{{ modalHeader }}</h4>
      </template>
      <template slot="body">
        {{ modalMessage }}
      </template>
    </modal>
  </div>
</template>

<script>
import DateRangeInput from '../inputs/DateRangeInput.vue'
import EmailInput from '../inputs/EmailInput.vue'
import Modal from '../Modal.vue'

export default {
  name: 'ANUUpload',
  components: {
    DateRangeInput,
    EmailInput,
    Modal
  },
  data () {
    return {
      count: 0,
      modalMessage: '',
      modalHeader: '',
      confirming: false,
      uploading: false,
      progress: 0,
      email: {
        name: 'email',
        label: 'Email',
        value: ''
      },
      dateRange: {
        name: 'dateRange',
        label: 'Report Date Range',
        type: 'date-range',
        fromValue: moment().subtract(1, 'month').startOf('month').format('DD/MM/YYYY'),
        toValue: moment().subtract(1, 'month').endOf('month').format('DD/MM/YYYY')
      },
      reservations: []
    }
  },
  mounted () {
    let token = window.sessionStorage.getItem('token')
    $('#anuFile').fileupload({
      url: '/api/admin/anu-uploader',
      headers: { Authorization: `Bearer ${token}` },
      type: 'POST',
      dataType: 'json',
      sequentialUploads: true,
      add: (e, data) => {
        this.hasError = false
        let uploadErrors = []
        let file = data.originalFiles[0]
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push('Filesize is too big')
        }
        if (uploadErrors.length > 0) {
          this.hasError = uploadErrors.join('\n')
        } else {
          data.submit()
        }
      },
      send: (e, data) => {
        this.uploading = true
      },
      progress: (e, data) => {
        this.progress = parseInt(data.loaded / data.total * 100, 10)
      },
      done: (e, data) => {
        this.progress = 0
        this.uploading = false
        this.reservations = data.result
      }
    })
  },
  methods: {
    emailReport () {
      let { meta } = this.$route.matched.find(m => m.meta.authType)
      this.$http.post(`${meta.authType}/object/emailANUStripeData`, { reservations: this.reservations, email: this.email }).then(({ data }, status, request) => {
        this.openModal('Success!', 'Your report was succesfully sent')
      }).catch(function (err) {
        this.openModal('There was an error processing your report...', err.data)
      })
    },
    openModal (header, message) {
      this.confirming = true
      this.modalHeader = header
      this.modalMessage = message
      this.$nextTick(function () {
        $(this.$refs.confirmationModal).modal()
        $(this.$refs.confirmationModal).on('hidden.bs.modal', (e) => {
          this.confirming = false
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/ANUUpload.vue